import Facebook from './Facebook'

export default Facebook
// eslint-disable-next-line import/export
export * from './Facebook'
